import { render, staticRenderFns } from "./CostUpdater.vue?vue&type=template&id=515128dc&scoped=true&lang=pug&"
import script from "./CostUpdater.vue?vue&type=script&lang=js&"
export * from "./CostUpdater.vue?vue&type=script&lang=js&"
import style0 from "./CostUpdater.vue?vue&type=style&index=0&id=515128dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515128dc",
  null
  
)

export default component.exports